// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EncuestasEdicionPage_modalOverlay__E\\+hOl {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.EncuestasEdicionPage_modalContent__HOEh3 {
  background: white;
  padding-left: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 50px;
  border-radius: 15px;
  width: 90vh;
  height: 56.25vw; /* 16:9 aspect ratio */
  max-height: 90vh;

  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.EncuestasEdicionPage_labelTitulo__0Id-8 {
  margin-left: 20px;
  padding-top: 30px;
}

.EncuestasEdicionPage_containerCuerpo__Hh-R8 {
  background-color: white;
}

.EncuestasEdicionPage_divFormulario__1lCyD {
  width: 100%;
}

p {
  width: 100%;
  flex-wrap: wrap;
}

.EncuestasEdicionPage_contenedorSeccionPreguntas__rjOw8 {
  border-radius: 15px;
  border-color: #bfbdbd;
  border-width: 1px;
  border-style: solid;
  display: flex;
  flex-direction: column;
}

.EncuestasEdicionPage_contenedorPregunta__NBYhG {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 15px;
  border-color: #bfbdbd;
  border-width: 1px;
  border-style: solid;
  margin: 10px;
  padding-left: 15px;
  flex-wrap: wrap;
  background-color: white;
}

.EncuestasEdicionPage_contenedorPregunta__NBYhG h3 {
  margin-left: 10px;
  font-size: 0.9rem;
  margin: 0px;
}
.EncuestasEdicionPage_contenedorPregunta__NBYhG .EncuestasEdicionPage_descripcionPregunta__yIwd9 {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  gap: 10px;
}

.EncuestasEdicionPage_contenedorPregunta__NBYhG .EncuestasEdicionPage_descripcionPreguntaDetalle__ZHeng {
  display: flex;

  flex-direction: row;
  justify-content: space-between;
}

.EncuestasEdicionPage_contenedorPregunta__NBYhG .EncuestasEdicionPage_miniBotonera__SLtY6 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  margin: 10px;
}

.EncuestasEdicionPage_contenedorSeccionPreguntas__rjOw8 .EncuestasEdicionPage_botoneraFinalSeccion__x9OPt {
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 20px;
}

.EncuestasEdicionPage_containerFilaBusqueda__HVCib {
  display: flex;

  align-items: center;
  padding: 0px;
  width: 100%;
  margin: 0px;
  justify-content: space-between;
}

.EncuestasEdicionPage_titulo__PmaAQ {
  font-weight: bold;
  font-size: 1.2rem;
  color: var(--text-color);
  margin-bottom: 20px;
  justify-self: flex-start;
  text-align: left;
  width: 100%;
  display: flex;
}

.EncuestasEdicionPage_divTodoEnUnaFila__CvBim {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
}

.EncuestasEdicionPage_divCampos__eaAF8 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  justify-items: flex-start;
  margin-left: 10px;
}

.EncuestasEdicionPage_divCamposItem__aenRz {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
  text-wrap: wrap;
  word-wrap: break-word;
}

.EncuestasEdicionPage_atributo__sPNgK {
  font-size: 0.8rem;
  font-weight: bold;
  text-wrap: nowrap;
  text-align: left;
  color: var(--text-color-claro);
}

.EncuestasEdicionPage_valor__b1wYt {
  font-size: 0.8rem;
  color: var(--text-color-claro-2);
  margin-left: 5px;
  text-align: left;
  word-wrap: break-word;
  max-width: 100%;
}

.EncuestasEdicionPage_divBotonera__31-9j {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.EncuestasEdicionPage_circleImage__bvSPk {
  width: 100%; /* Ajusta el tamaño según tus necesidades */
  height: 150px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
  border-radius: 8px; /* Esto crea el círculo */
  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */
  margin-right: 0px;
  border-width: 1px;
  border-style: solid;
}

.EncuestasEdicionPage_containerUsuario__HJJad {
  width: 100%;
  border-radius: 15px;
  border-color: gray;
  border-width: 1px;
  border-style: solid;

  padding: 10px;
  margin: 10px; /* Agrega un poco de margen entre los botones */
}

@media (min-width: 768px) {
  /* Ajusta este valor según tus necesidades */
  .EncuestasEdicionPage_containerGrillaUsuarios__fGIEe {
    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */
    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */
    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */
  }

  .EncuestasEdicionPage_containerUsuario__HJJad {
    /* Asume que esta es la clase de tus BotonCardComponent */
    flex: 1 1 45%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */
    max-width: 45%; /* Asegura que los botones no sean más anchos que el 30% */
    margin: 10px; /* Agrega un poco de margen entre los botones */
  }

  .EncuestasEdicionPage_circleImage__bvSPk {
    width: 30%; /* Ajusta el tamaño según tus necesidades */
    height: auto; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
    border-radius: 50%; /* Esto crea el círculo */
    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */

    border-width: 1px;
    border-style: solid;
  }
}

@media (min-width: 1100px) {
  .EncuestasEdicionPage_containerUsuario__HJJad {
    /* Asume que esta es la clase de tus BotonCardComponent */
    flex: 1 1 30%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */
    max-width: 28%; /* Asegura que los botones no sean más anchos que el 30% */
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/panel/encuestas/encuestas-edicion/EncuestasEdicionPage.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe,EAAE,sBAAsB;EACvC,gBAAgB;;EAEhB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;;EAEb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;;EAEb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW,EAAE,2CAA2C;EACxD,aAAa,EAAE,8EAA8E;EAC7F,kBAAkB,EAAE,yBAAyB;EAC7C,iBAAiB,EAAE,wEAAwE;EAC3F,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;;EAEnB,aAAa;EACb,YAAY,EAAE,+CAA+C;AAC/D;;AAEA;EACE,4CAA4C;EAC5C;IACE,mBAAmB,EAAE,sEAAsE;IAC3F,eAAe,EAAE,mFAAmF;IACpG,2BAA2B,EAAE,qDAAqD;EACpF;;EAEA;IACE,yDAAyD;IACzD,aAAa,EAAE,0HAA0H;IACzI,cAAc,EAAE,0DAA0D;IAC1E,YAAY,EAAE,+CAA+C;EAC/D;;EAEA;IACE,UAAU,EAAE,2CAA2C;IACvD,YAAY,EAAE,8EAA8E;IAC5F,kBAAkB,EAAE,yBAAyB;IAC7C,iBAAiB,EAAE,wEAAwE;;IAE3F,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,yDAAyD;IACzD,aAAa,EAAE,0HAA0H;IACzI,cAAc,EAAE,0DAA0D;EAC5E;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background: white;\n  padding-left: 20px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding-right: 50px;\n  border-radius: 15px;\n  width: 90vh;\n  height: 56.25vw; /* 16:9 aspect ratio */\n  max-height: 90vh;\n\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.labelTitulo {\n  margin-left: 20px;\n  padding-top: 30px;\n}\n\n.containerCuerpo {\n  background-color: white;\n}\n\n.divFormulario {\n  width: 100%;\n}\n\np {\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.contenedorSeccionPreguntas {\n  border-radius: 15px;\n  border-color: #bfbdbd;\n  border-width: 1px;\n  border-style: solid;\n  display: flex;\n  flex-direction: column;\n}\n\n.contenedorPregunta {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-radius: 15px;\n  border-color: #bfbdbd;\n  border-width: 1px;\n  border-style: solid;\n  margin: 10px;\n  padding-left: 15px;\n  flex-wrap: wrap;\n  background-color: white;\n}\n\n.contenedorPregunta h3 {\n  margin-left: 10px;\n  font-size: 0.9rem;\n  margin: 0px;\n}\n.contenedorPregunta .descripcionPregunta {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  margin-left: 10px;\n  margin-right: 10px;\n  gap: 10px;\n}\n\n.contenedorPregunta .descripcionPreguntaDetalle {\n  display: flex;\n\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.contenedorPregunta .miniBotonera {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 10px;\n  margin: 10px;\n}\n\n.contenedorSeccionPreguntas .botoneraFinalSeccion {\n  display: flex;\n  justify-content: center;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n\n.containerFilaBusqueda {\n  display: flex;\n\n  align-items: center;\n  padding: 0px;\n  width: 100%;\n  margin: 0px;\n  justify-content: space-between;\n}\n\n.titulo {\n  font-weight: bold;\n  font-size: 1.2rem;\n  color: var(--text-color);\n  margin-bottom: 20px;\n  justify-self: flex-start;\n  text-align: left;\n  width: 100%;\n  display: flex;\n}\n\n.divTodoEnUnaFila {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n}\n\n.divCampos {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-content: flex-start;\n  justify-content: flex-start;\n  justify-items: flex-start;\n  margin-left: 10px;\n}\n\n.divCamposItem {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n  text-wrap: wrap;\n  word-wrap: break-word;\n}\n\n.atributo {\n  font-size: 0.8rem;\n  font-weight: bold;\n  text-wrap: nowrap;\n  text-align: left;\n  color: var(--text-color-claro);\n}\n\n.valor {\n  font-size: 0.8rem;\n  color: var(--text-color-claro-2);\n  margin-left: 5px;\n  text-align: left;\n  word-wrap: break-word;\n  max-width: 100%;\n}\n\n.divBotonera {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.circleImage {\n  width: 100%; /* Ajusta el tamaño según tus necesidades */\n  height: 150px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n  border-radius: 8px; /* Esto crea el círculo */\n  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n  margin-right: 0px;\n  border-width: 1px;\n  border-style: solid;\n}\n\n.containerUsuario {\n  width: 100%;\n  border-radius: 15px;\n  border-color: gray;\n  border-width: 1px;\n  border-style: solid;\n\n  padding: 10px;\n  margin: 10px; /* Agrega un poco de margen entre los botones */\n}\n\n@media (min-width: 768px) {\n  /* Ajusta este valor según tus necesidades */\n  .containerGrillaUsuarios {\n    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */\n    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */\n    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */\n  }\n\n  .containerUsuario {\n    /* Asume que esta es la clase de tus BotonCardComponent */\n    flex: 1 1 45%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */\n    max-width: 45%; /* Asegura que los botones no sean más anchos que el 30% */\n    margin: 10px; /* Agrega un poco de margen entre los botones */\n  }\n\n  .circleImage {\n    width: 30%; /* Ajusta el tamaño según tus necesidades */\n    height: auto; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n    border-radius: 50%; /* Esto crea el círculo */\n    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n\n    border-width: 1px;\n    border-style: solid;\n  }\n}\n\n@media (min-width: 1100px) {\n  .containerUsuario {\n    /* Asume que esta es la clase de tus BotonCardComponent */\n    flex: 1 1 30%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */\n    max-width: 28%; /* Asegura que los botones no sean más anchos que el 30% */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `EncuestasEdicionPage_modalOverlay__E+hOl`,
	"modalContent": `EncuestasEdicionPage_modalContent__HOEh3`,
	"labelTitulo": `EncuestasEdicionPage_labelTitulo__0Id-8`,
	"containerCuerpo": `EncuestasEdicionPage_containerCuerpo__Hh-R8`,
	"divFormulario": `EncuestasEdicionPage_divFormulario__1lCyD`,
	"contenedorSeccionPreguntas": `EncuestasEdicionPage_contenedorSeccionPreguntas__rjOw8`,
	"contenedorPregunta": `EncuestasEdicionPage_contenedorPregunta__NBYhG`,
	"descripcionPregunta": `EncuestasEdicionPage_descripcionPregunta__yIwd9`,
	"descripcionPreguntaDetalle": `EncuestasEdicionPage_descripcionPreguntaDetalle__ZHeng`,
	"miniBotonera": `EncuestasEdicionPage_miniBotonera__SLtY6`,
	"botoneraFinalSeccion": `EncuestasEdicionPage_botoneraFinalSeccion__x9OPt`,
	"containerFilaBusqueda": `EncuestasEdicionPage_containerFilaBusqueda__HVCib`,
	"titulo": `EncuestasEdicionPage_titulo__PmaAQ`,
	"divTodoEnUnaFila": `EncuestasEdicionPage_divTodoEnUnaFila__CvBim`,
	"divCampos": `EncuestasEdicionPage_divCampos__eaAF8`,
	"divCamposItem": `EncuestasEdicionPage_divCamposItem__aenRz`,
	"atributo": `EncuestasEdicionPage_atributo__sPNgK`,
	"valor": `EncuestasEdicionPage_valor__b1wYt`,
	"divBotonera": `EncuestasEdicionPage_divBotonera__31-9j`,
	"circleImage": `EncuestasEdicionPage_circleImage__bvSPk`,
	"containerUsuario": `EncuestasEdicionPage_containerUsuario__HJJad`,
	"containerGrillaUsuarios": `EncuestasEdicionPage_containerGrillaUsuarios__fGIEe`
};
export default ___CSS_LOADER_EXPORT___;
